import { getUserInfo } from "./helpers";

const ROLE_PRIORITY = {
  "Admin": 1,
  "Chief Inspector": 2,
  "Welding Inspector": 3,
  "Supplier": 4
};

export const setPermissions = (data) => {
  localStorage.setItem("permissions", JSON.stringify(data));
};

const getPermissions = () => {
  return JSON.parse(localStorage.getItem("permissions"));
};

const mapPermissionsByProject = (data) => {
  const permissionsByProject = {};

  data?.userProjectPermissions?.forEach((project) => {
    const { projectId, projectRoles } = project;

    const sortedRoles = [...projectRoles].sort(
      (a, b) =>
        ROLE_PRIORITY[a.contractorRoleName] - ROLE_PRIORITY[b.contractorRoleName]
    );

    const topRole = sortedRoles[0];

    const permissions = {};
    topRole.rolesPermissions.forEach((perm) => {
      permissions[perm.permissionName] = perm.hasAccess;
    });

    permissionsByProject[projectId] = {
      role: topRole.contractorRoleName,
      permissions,
    };
  });

  return permissionsByProject;
};

export const getUserPermissions = () => {
  const permissions = getPermissions();
  return Object.keys(permissions).length > 0 ? mapPermissionsByProject(permissions) : {};
};

export const getUserPermissionsLogin = (permissions) => {
  return Object.keys(permissions).length > 0 ? mapPermissionsByProject(permissions) : {};
};

export const hasPermission = (projectId, permissionName) => {
  const userPermissions = getUserPermissions();
  
  const projectPermissions = userPermissions[projectId]?.permissions;
  
  if (projectPermissions && projectPermissions[permissionName] !== undefined) {
    return projectPermissions[permissionName] === true;
  }
  
  const globalPermissions = userPermissions[null]?.permissions;
  if (globalPermissions && globalPermissions[permissionName] !== undefined) {
    return globalPermissions[permissionName] === true;
  }
  
  return false;
};
